import { PipedreamService } from '@/lib/Services/PipedreamService';

declare function cometToken(): string | undefined;
declare function cometFingerprint(): Promise<string | undefined>;

export async function conversionContext() {
  const ipAddress = await PipedreamService.getUserIpAddress();
  let comet_token: string | undefined;
  let fingerprint: string | undefined;
  try {
    if (typeof cometToken === 'function') comet_token = cometToken();
    if (typeof cometFingerprint === 'function') {
      fingerprint = await cometFingerprint();
    }
  } catch (e) {
    console.error('[Cometly] Error fetching Cometly data:', e);
  }
  return { ip: ipAddress.data.ip, cometly: { comet_token, fingerprint } };
}
